module.exports = new __parcel__URL__("8206_sq.15ebc978.jpg").toString();